import { graphql } from "@/data-access/graphql";

const NewsAlertLogoFragment = graphql(`
  fragment NewsAlertLogoFragment on NewsAlertLogoType @_unmask {
    __typename
    id
    logoUrl
    logo {
      __typename
      height
      name
      size
      url
      width
    }
  }
`);

const NewsAlertSectionFragment = graphql(`
  fragment NewsAlertSectionFragment on NewsAlertSectionType @_unmask {
    id
    name
    articleLimit
    sortOrder
    savedView {
      id
      name
      urlSelectedFilters
    }
    feed {
      id
    }
  }
`);

export const NewsAlertFragment = graphql(
  `
  fragment NewsAlertFragment on NewsAlertType @_unmask {
        __typename
        id
        name
        recipients
        scheduleType
        timezone
        description
        sendAt
        sendOn
        updatedAt
        sections {
          ...NewsAlertSectionFragment
        }
        createdBy {
          id
          name
        }
        alertLogo {
          ...NewsAlertLogoFragment
        }
    }
`,
  [NewsAlertLogoFragment, NewsAlertSectionFragment],
);

/** List-row fields only; omits sections/alertLogo so graphcache won't expect them on briefings. */
export const NewsAlertSchedulerTableFragment = graphql(`
  fragment NewsAlertSchedulerTableFragment on NewsAlertType @_unmask {
    __typename
    id
    name
    recipients
    scheduleType
    timezone
    description
    sendAt
    sendOn
    updatedAt
    createdBy {
      id
      name
    }
  }
`);
